<svelte:options accessors/>
<script>
    import { createEventDispatcher, onMount, tick } from "svelte";
    import { toCOP } from "../utils/utils";

    const dispatch = new createEventDispatcher();

    export let id = '1';
    export let amount;
    export let action = 'patrocinar';
    export let bigSize = false;

    export let values = [0];
    let active = 0;
    let valid = true;

    $: minValue = values[0];

    onMount(() => {
        let amountIndex = values.indexOf(amount);
        if (amount > 0 && amountIndex >= 0) {
            active = amountIndex;
        } else {
            active = values.length - 1;
        }
    });

    async function activate(index) {
        active = index;
        amount = values[index];
        await tick();
        if (amount === 0) {
            valid = false;
            document.getElementById('input-' + id).value = '';
            document.getElementById('input-' + id).focus();
        } else {
            valid = true;
            dispatch('amountChange', amount);
        }
    }

    function onInputChange(event) {
        if (event.target.value < minValue) {
            valid = false;
        } else {
            valid = true;
            amount = parseInt(event.target.value);
            dispatch('amountChange', amount);
        }
    }

</script>
<div class="amount" class:big={bigSize}>
    <div class="grid-2 gap-ii max-w-300px my-1">
        {#each values as value, i (value) }
            <div class="btn" class:small={!bigSize} class:active={active===i} on:click={activate.bind(this, i)}>
                {#if value > 0}
                    ${toCOP(value)}
                {:else}
                    Otro valor
                {/if}
            </div>
        {/each}
    </div>
    {#if values[active] === 0}
        <input id="input-{id}" bind:value={amount} type="number" min={minValue} on:input={onInputChange}
               class="naui-input mb-i w-100" placeholder="Ingresa el valor">
    {/if}
    {#if !valid}
        <small class="error">El valor debe ser superior a ${toCOP(minValue)}</small>
    {/if}
    {#if action !== 'taller'}
    <div>
        <small class="text-light">* Recuerda que puedes {action} desde ${toCOP(minValue)}</small>
    </div>
    {/if}
</div>
<style>
    .btn {
        color: var(--text-light);
        font-weight: 400;
        background: var(--back-gray);
        border: none;
        transition: .15s;
    }

    .btn:hover {
        background: #f2f2f2;
    }

    .btn.active {
        color: var(--secondary);
        border: 1px solid var(--secondary);
    }

    small {
        font-size: 14px;
    }

    .naui-input {
        height: 35px;
    }

    .error {
        color: var(--primary);
        margin-top: .25rem;
        margin-bottom: .25rem;
        display: block;
    }

    .amount.big .grid-2{
        max-width: 350px;
    }

    .amount.big .btn{
        font-size: 1rem;
    }
</style>
